import { Component, inject } from '@angular/core';
import { BaseDialogComponent } from '../../../../../kit/base-dialog/base-dialog.component';
import { WorkSuggestionPageComponent } from '../work-suggestion-page.component';
import { WorkDataSuggestionTypeEnum } from '@libs/types/src/services/enum/work-data-suggestion-type.enum';
import { FolderGlobalStore } from '../../../../../../store/medicalService/folder.global-store';
import { routeParams } from '../../../../../../modules/shared/shared.global-service';

@Component({
    selector: 'app-work-suggestion-dialog',
    templateUrl: './work-suggestion-dialog.component.html',
    styleUrl: './work-suggestion-dialog.component.scss',
    imports: [WorkSuggestionPageComponent],
})
export class WorkSuggestionDialogComponent extends BaseDialogComponent {

    protected readonly suggestionType: WorkDataSuggestionTypeEnum = this.dialogConfig.data?.suggestionType;
    protected readonly folderStore = inject(FolderGlobalStore);

    constructor() {
        super();
        this.folderStore.setFolderId(routeParams.folderId());
        this.folderStore.setDialogComponent(this);
    }

}
